import React from "react";

export default function Emblem({ size = 72, className = "" }) {
  return (
    <img src="/logo.png" width={size} height={size} alt="Okuapemman Association of Massachusetts emblem"
      className={`object-contain ${className}`} style={{ width: size, height: size }} data-testid="emblem" />
  );
}
